query ProductLineCounts(
    $filter: ProductSearchInput!
    $parameterIDs: [ID!]!
) {
    searchProducts(filter: $filter) {
        facets {
            propertyValues(parameterIDs: $parameterIDs) {
                value
                count
            }
        }
    }
}
